import {Routes} from '@angular/router';

export const rollManagementRoutes: Routes = [
  {
    path: 'rollManagement',
    loadComponent: () => import('./roll-management.component').then(m => m.RollManagementComponent),
    children: [
      {
        path: 'coupon.mgr',
        loadComponent: () => import('./coupon-mgr/coupon-mgr.component').then(m => m.CouponMgrComponent),
        data: {key: "01JEDNJ129BA892M60QZPFP7KW", keep: true},
      },
      {
        path: 'release.sku.coupon.binding',
        loadComponent: () => import('./release-sku-coupon-binding/release-sku-coupon-binding.component').then(m => m.ReleaseSkuCouponBindingComponent),
        data: {key: "01JEDNHYBJNDET3TDZESZHTS2Q", keep: true},
      },
      {
        path: 'coupontheme.mgr',
        loadComponent: () => import('./coupontheme-mgr/coupontheme-mgr.component').then(m => m.CouponthemeMgrComponent),
        data: {key: "01JEDNHV2ETN7QS4HG2X6DEY0N", keep: true},
      },
      {
        path: 'voucher.mgr',
        loadComponent: () => import('./voucher-mgr/voucher-mgr.component').then(m => m.VoucherMgrComponent),
        data: {key: "01JEDNGYWYGM6KCZMJDC1RNTK8", keep: true},
      },
      {
        path: 'release.sku.voucher.binding',
        loadComponent: () => import('./release-sku-voucher-binding/release-sku-voucher-binding.component').then(m => m.ReleaseSkuVoucherBindingComponent),
        data: {key: "01JEDNHNK0AERR0RPTXYMSAE5P", keep: true},
      },
      {
        path: 'waterCouponMgr',
        loadComponent: () => import('./water-coupon-mgr/water-coupon-mgr.component').then(m => m.WaterCouponMgrComponent),
        data: {title: '桶装水卷管理'},
      },
      {
        path: 'waterCouponDetailMgr/:id',
        loadComponent: () => import('./water-coupon-mgr/water-coupon-detail-mgr/water-coupon-detail-mgr.component').then(m => m.WaterCouponDetailMgrComponent),
        data: {title: '桶装水卷明细管理'},
      },
    ]
  },
];
